module.exports = __webpack_public_path__ + "static/media/pexels-photo-306534.34c0172d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/app2soft/images/007_de/pexels-photo-306534.jpeg
// module id = 781
// module chunks = 0